import * as React from "react";
const RecordingRedoSvg = (props) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.333 5.333C12.398 3.36 10.358 2 8 2a6 6 0 1 0 6 6m0-6v4h-4"
      stroke="#525252"
      strokeWidth={1.5}
    />
  </svg>
);
export default RecordingRedoSvg;
